import { FC } from 'react'
import styled from 'styled-components'
import { ArrowRight } from 'svgIcons'
import Button from '@app.components/Button'
import { ButtonProps } from '@app.components/Button/Button'

interface PredictionButtonProps extends ButtonProps {}

const PredictionButton: FC<PredictionButtonProps> = ({
  children,
  color = 'prediction',
  ...props
}) => {
  return (
    <StyledWrapper
      color={color}
      {...props}
      endIcon={<ArrowRight className="arrow-icon" />}
    >
      <span>{children}</span>
    </StyledWrapper>
  )
}

export default PredictionButton

const StyledWrapper = styled(Button)`
  width: 460px;
  height: 76px;
  border-radius: 10px;
  gap: 4px;

  .arrow-icon {
    width: 18px;
    height: 18px;
  }

  > span {
    font-size: 22px;
    font-weight: bold;
    line-height: 1.95;
    letter-spacing: -0.88px;
    text-align: center;
  }
`
